module.exports = __webpack_public_path__ + "static/media/gc-puzzle-acropole.97eec3c9.png";